import React, { FC } from 'react'

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import toast from 'react-hot-toast'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'

import { Box } from '@material-ui/core'

import TextField from '~/components/fields/TextField'
import ExtendedButton from '~/components/shared/ExtendedButton'
import Text from '~/components/shared/Text'

import SubscribeSchema from '~/schemas/subscibe'
import EmpriseGroup from '~/services/EmpriseGroup'
import { asyncValidate } from '~/utils/asyncValidate'
import { createSubmit } from '~/utils/createSubmit'
import ErrorHandler from '~/utils/errorHandler'

import Subscribe from '~/assets/icons/telegram.svg?sprite'

import { SubscribeNewsletterInput } from '~/interfaces/inputs'

import { useStyles } from './BlogSubscribe.style'

const BlogSubscribe: FC<InjectedFormProps<SubscribeNewsletterInput>> = ({
  handleSubmit
}) => {
  const classes = useStyles()
  const { executeRecaptcha } = useGoogleReCaptcha()

  const onSubmit = handleSubmit(async (values) => {
    try {
      if (!executeRecaptcha) throw new Error('ReCaptcha is not loaded yet')

      const captchaToken = await executeRecaptcha('subscribe_email_newsletter')

      await EmpriseGroup.emailSubscribe({
        email: values.email,
        captcha_token: captchaToken
      })
    } catch (error) {
      throw new ErrorHandler(error)
    }
  })

  return (
    <Box
      bgcolor="bg.secondary"
      p={2}
      component="form"
      className={classes.container}
      onSubmit={createSubmit({ handleSubmit: onSubmit })}
    >
      <Text fontWeight={600} fontSize={20} mb={2}>
        Follow the journey
      </Text>
      <Text fontWeight={400} fontSize={16} mb={3} className={classes.subtitle}>
        Subscribe to our email newsletter for useful tips and valuable resources
        sent out every second week.
      </Text>
      <Field
        id="email"
        placeholder="Email Address"
        name="email"
        autoComplete="email"
        component={TextField}
      />
      <ExtendedButton
        className={classes.subscribeBtn}
        mt={1}
        fullWidth
        type="submit"
      >
        <Subscribe />
        <Text fontWeight={600}>Subscribe</Text>
      </ExtendedButton>
    </Box>
  )
}

const withForm = reduxForm<SubscribeNewsletterInput>({
  form: 'Blog_Subscribe_Form',
  shouldAsyncValidate: () => true,
  destroyOnUnmount: true,
  asyncBlurFields: [],
  asyncValidate: asyncValidate(SubscribeSchema),
  onSubmitSuccess: (_values, _dispatch, { reset }) => {
    toast.success('Success!')
    reset()
  }
})

export default withForm(BlogSubscribe)
